// Ширина карточки на мобильном устройстве
export const SLIDE_WIDTH = 232;

// Отступы десктопного слайдера
export const DESKTOP_SLIDER_INDENTS = {
  left: 42,
  right: 42,
  beetween: 16,
  // отступ для тултипа позиции
  top: 60,
  // отступ для тени карточек
  bottom: 16,
};

// Отступы мобильного слайдера
export const MOBILE_SLIDER_INDENTS = {
  left: 16,
  right: 16,
  beetween: 16,
  // отступ для тени карточек
  bottom: 16,
};
